uniform sampler2D               u_tex0;
uniform vec2                    u_tex0Resolution;

uniform sampler2D               u_buffer0; // 540x960

// IBL
uniform samplerCube             u_cubeMap;
uniform vec3                    u_SH[9];

// Scene
uniform sampler2D               u_scene;
uniform sampler2D               u_sceneDepth;

uniform mat4                    u_viewMatrix;

uniform vec3                    u_camera;
uniform float                   u_cameraDistance;
uniform float                   u_cameraNearClip;
uniform float                   u_cameraFarClip;

uniform vec2                    u_resolution;
#define RESOLUTION              u_resolution
uniform vec2                    u_mouse;
uniform float                   u_time;


#if !defined(POSTPROCESSING) && !defined(BACKGROUND) && !defined(BUFFER_0)
// Shadow
uniform sampler2D               u_lightShadowMap;
uniform mat4                    u_lightMatrix;
uniform vec3                    u_light;
uniform vec3                    u_lightColor;
uniform float                   u_lightIntensity;
varying vec4                    v_lightCoord;
#define LIGHT_DIRECTION         u_light
#define LIGHT_COORD             v_lightCoord
#define LIGHT_COLOR             u_lightColor
#define LIGHT_INTENSITY         u_lightIntensity

// Surface position (from vertex shader - common)
varying vec4                    v_position;
#define SURFACE_POSITION        v_position

// More model data (from vertex shader - common)
#define MODEL_VERTEX_TANGENT    v_tangent
varying vec4                    v_color;
varying vec3                    v_normal;
#define MODEL_VERTEX_NORMAL     v_normal
varying vec2                    v_texcoord;
#define MODEL_VERTEX_TEXCOORD   v_texcoord
#endif

#include "lygia/space/ratio.glsl"
#include "lygia/space/scale.glsl"

#define CIRCLESDF_FNC(POS_UV) (dot(POS_UV, POS_UV) )
#include "lygia/sdf/circleSDF.glsl"

#define BARREL_DISTANCE dist*dist
#define BARREL_OCT_1
#include "lygia/distort/barrel.glsl"
#define CHROMAAB_CENTER_BUFFER .15
#define CHROMAAB_SAMPLER_FNC(TEX, POS_UV) barrel(TEX, POS_UV, -offset.x)
#include "lygia/distort/chromaAB.glsl"

// PBR pipeline
#define CAMERA_POSITION     u_camera
#include "lygia/lighting/material/new.glsl"
#include "lygia/lighting/pbr.glsl"

void main() {
    vec4 color = vec4(0.0);
    vec2 pixel = 1.0 / u_resolution;
    vec2 st = gl_FragCoord.xy * pixel;

    vec2 res = vec2(540.0, 960.0)*0.5;
    

    #if defined(BUFFER_0)
        float u_col = 8.0;
        float u_row = 3.0;

        vec2 nRes = vec2(u_col,u_row);
        float nFrames = u_col * u_row;
        vec2 fRes = u_tex0Resolution / nRes;
        float image_ratio = fRes.x / fRes.y;
        float screen_ratio = res.x / res.y;

        vec2 uv = st;
        // uv = scale(uv, 1.2);
        uv.y *= image_ratio / screen_ratio;
        uv.y += (1.0 - image_ratio / screen_ratio) * 0.5;
        uv = uv/nRes;

        float timeX = mod(u_time * 7.5, nFrames);
        // timeX = mod(u_time * 7.5 * 3., nFrames);
        float timeY = floor(timeX/u_col);
        vec2 offset = vec2( floor(timeX)/nRes.x,
                            1.0-(floor(timeY)/nRes.y) );
        uv = fract(uv + offset);
        color = texture2D(u_tex0, uv);

    #else
        vec2 uv = v_texcoord;
        uv = scale(uv, vec2(.9, 1.));
        uv.y = 1.0 - uv.y;

        vec2 st_r = ratio(uv, res);
        float sdf = circleSDF(st_r) * 0.5;

        // 3D PBR Scene 
        Material material = materialNew();
        material.albedo.rgb = chromaAB(u_buffer0, uv, sdf, 1.) * 3.0;
        material.roughness = 0.01;
        material.metallic = 0.0;
        color = pbr(material);

    #endif


    gl_FragColor = color;
}